import * as z from "zod";
import { userFacingError } from "../authorization";
import { USER_ACTION_TOOLS } from "../clientAutoResolvedTools";
import { zql } from "../generatedDrizzleSchema";
import { actorColumns } from "../rbac/roles";
import { mutator } from "./mutator";
import { applyToolResult } from "./provideToolResultShared";

export const provideSpaceChatToolResultSchema = z.object({
  chatId: z.string(),
  entryId: z.string(),
  outputId: z.string(),
  isError: z.boolean().optional(),
  branchId: z.string(),
  pauseAfter: z.boolean().optional(),
  chatModel: z.string().optional(),
});

export const provideSpaceChatToolResult = mutator({
  schema: provideSpaceChatToolResultSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const { chatId, branch, pauseAfter } = args;
    const [chat] = await tx.run(
      zql.chats
        .where("id", chatId)
        .related("commit", (c) => c.where("branchId", branch.id))
    );
    if (!chat?.commit) throw userFacingError("Chat not found on branch");
    if (chat.commit.id !== branch.headCommitId)
      throw userFacingError(
        "Cannot answer a tool call in a historical workflow version"
      );

    const toolCall = await applyToolResult(tx, args);
    const { userId } = actorColumns(ctx);
    if (USER_ACTION_TOOLS.has(toolCall.toolName) && userId) {
      await tx.mutate.branchContributors.insert({
        branchId: branch.id,
        workflowId: branch.workflowId,
        userId,
        lastMessagedAt: null,
        tenantId: ctx.tenantId,
      });
    }

    await tx.mutate.chats.update({
      id: chatId,
      respondingAt: pauseAfter ? null : Date.now(),
      awaitingAction: false,
    });
  },
});
